import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Condolence\SendAllCondoleancesController::__invoke
* @see app/Http/Controllers/Condolence/SendAllCondoleancesController.php
* @route '/api/condolence/send-all'
*/
const SendAllCondoleancesController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendAllCondoleancesController.url(options),
    method: 'post',
})

SendAllCondoleancesController.definition = {
    methods: ["post"],
    url: '/api/condolence/send-all',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Condolence\SendAllCondoleancesController::__invoke
* @see app/Http/Controllers/Condolence/SendAllCondoleancesController.php
* @route '/api/condolence/send-all'
*/
SendAllCondoleancesController.url = (options?: RouteQueryOptions) => {
    return SendAllCondoleancesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Condolence\SendAllCondoleancesController::__invoke
* @see app/Http/Controllers/Condolence/SendAllCondoleancesController.php
* @route '/api/condolence/send-all'
*/
SendAllCondoleancesController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SendAllCondoleancesController.url(options),
    method: 'post',
})

export default SendAllCondoleancesController